<template>
  <Document :docUri="query.docUri"/>
</template>

<script>
import Document from '@/components/pages/Document';

export default {
  name: 'pronuncia',
  components: {
    Document,
  },
  breadcrumb: {
    label: 'Pronuncia',
    parent: 'pronunce',
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      query: this.$route.query,
    };
  },
};
</script>

<style scoped>
</style>






// WEBPACK FOOTER //
// src/components/pages/Pronuncia.vue